import { Page } from '@/core/architecture'

import { ArtistMembershipPurchaseConfirmationTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ArtistMembershipPurchaseConfirmation Page
 * Implemented as a practical sample.
 */
export const ArtistMembershipPurchaseConfirmation: Page = () => {
  const { state, actions } = useViewModel()

  return (
    <ArtistMembershipPurchaseConfirmationTemplate state={state} {...actions} />
  )
}
